<template>
    <div class="dashboard">
        <!-- 概览指标 -->
        <el-row :gutter="12">
            <el-col v-for="stat in statList" :key="stat.code" :xs="12" :sm="12" :md="6">
                <el-card shadow="hover" class="stat-card" :class="'stat-card--' + stat.code">
                    <div class="stat-card__inner">
                        <div class="stat-card__icon">
                            <el-icon :size="20"><component :is="stat.icon" /></el-icon>
                        </div>
                        <div class="stat-card__main">
                            <div class="stat-card__label">{{ stat.label }}</div>
                            <div class="stat-card__value">{{ stat.value }}</div>
                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>

        <!-- 月度文章发布统计图
        发布动态 -->
        <el-card shadow="never" class="panel-card">
            <template #header>
                <div class="panel-card__header">
                    <span class="panel-card__title">数据趋势</span>
                </div>
            </template>
            <div id="myChart" class="trend-chart"></div>
        </el-card>

        <!-- 我的文档阅读记录 -->
        <el-card shadow="never" class="panel-card">
            <template #header>
                <div class="panel-card__header">
                    <span class="panel-card__title">我的文档阅读记录</span>
                </div>
            </template>
            <el-table :data="myDocReadLog" class="read-log-table" style="width: 100%" height="360" stripe>
                <el-table-column prop="readTime" label="阅读时间" width="180" />
                <el-table-column prop="collectedName" label="文集" width="200" />
                <el-table-column prop="docTitle" label="文档" width="300" />
                <!-- <el-table-column prop="createUser" label="创建" width="120" /> -->
                <el-table-column prop="ownerUser" label="管理" width="120" />
                <el-table-column prop="readUser" label="读者" width="120" />
                <el-table-column prop="ip" label="访问IP" width="120" />
            </el-table>
        </el-card>
    </div>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../utils/request.js';
export default {
    data() {
        return {
            collectedCount: 0,
            docCount: 0,
            cursorCount: 0,
            readCount: 0,
            trendChartData: {
                dateList: [],
                collectedCountList: [],
                cursorCountList: [],
                docCountList: [],
                docUpdateCountList: [],
                readCountList: []
            },
            myDocReadLog: []
        };
    },
    computed: {
        // 概览指标，仅用于展示层组合，数据来源保持原样
        statList() {
            return [
                { code: 'collected', label: '文集数量', value: this.collectedCount, icon: 'Collection' },
                { code: 'doc', label: '文档数量', value: this.docCount, icon: 'Document' },
                { code: 'file', label: '文件数量', value: this.cursorCount, icon: 'FolderOpened' },
                { code: 'read', label: '阅读数量', value: this.readCount, icon: 'View' }
            ];
        }
    },
    mounted() {
        console.log('DashBoard mounted ~');
        this.loadUserBoard();
        this.initChart();
        //this.$root => app
        console.log(this.echarts);

        this.loadMyDocReadLog();

        window.addEventListener('resize', this.resizeChart);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.resizeChart);
    },
    created(){
        console.log('DashBoard created ~');
    },
    methods: {
        // 窗口尺寸变化时让图表跟随容器重新计算尺寸
        resizeChart() {
            const chartDom = document.getElementById('myChart');
            if (!chartDom) {
                return;
            }
            const chart = this.$echarts.getInstanceByDom(chartDom);
            if (chart) {
                chart.resize();
            }
        },
        loadUserBoard() {
            request({
                url: '/user/currentUserBoard',
                method: 'post'
            }).then(res => {
                if (res.code == 0) {
                    this.collectedCount = res.meta.collectedCount;
                    this.docCount = res.meta.docCount;
                    this.cursorCount = res.meta.cursorCount;
                    this.readCount = res.meta.readCount;
                    this.trendChartData = res.meta.trendChartData;

                    // this.$nextTick(() => {
                    this.initChart();
                    // });
                }
            });
        },
        loadMyDocReadLog() {
            request({
                url: '/dashboard/myDocReadLog',
                method: 'post',
                data: {
                    docId: ''
                }
            }).then(res => {
                if (res.code == 0 && res.data.length > 0) {
                    this.myDocReadLog = res.data;
                }
            });
        },
        initChart() {
            let myChart = this.$echarts.init(document.getElementById('myChart'));
            // 绘制图表
            myChart.setOption({
                color: ['#5B8FF9', '#5AD8A6', '#F6BD16', '#E8684A', '#9270CA'],
                tooltip: {
                    trigger: 'axis',
                    backgroundColor: 'rgba(255, 255, 255, 0.96)',
                    borderColor: '#eef0f4',
                    borderWidth: 1,
                    padding: [8, 12],
                    textStyle: { color: '#1f2d3d', fontSize: 12 },
                    axisPointer: { type: 'line', lineStyle: { color: '#dfe3ea', type: 'dashed' } }
                },
                legend: {
                    bottom: 0,
                    icon: 'circle',
                    itemWidth: 8,
                    itemHeight: 8,
                    itemGap: 18,
                    textStyle: { color: '#8a94a6', fontSize: 12 }
                },
                grid: { top: 24, left: 8, right: 16, bottom: 40, containLabel: true },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.trendChartData.dateList,
                    axisLine: { lineStyle: { color: '#e8ebf0' } },
                    axisTick: { show: false },
                    axisLabel: { color: '#8a94a6', fontSize: 11 }
                },
                yAxis: {
                    type: 'value',
                    axisLine: { show: false },
                    axisTick: { show: false },
                    axisLabel: { color: '#8a94a6', fontSize: 11 },
                    splitLine: { lineStyle: { color: '#f0f2f6', type: 'dashed' } }
                },
                series: [
                    {
                        name: '文集数量',
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: { width: 2 },
                        emphasis: { focus: 'series' },
                        data: this.trendChartData.collectedCountList
                    },
                    {
                        name: '文档数量',
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: { width: 2 },
                        emphasis: { focus: 'series' },
                        data: this.trendChartData.docCountList
                    },
                    {
                        name: '文档编辑',
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: { width: 2 },
                        emphasis: { focus: 'series' },
                        data: this.trendChartData.docUpdateCountList
                    },
                    {
                        name: '文件数量',
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: { width: 2 },
                        emphasis: { focus: 'series' },
                        data: this.trendChartData.cursorCountList
                    },
                    {
                        name: '阅读数量',
                        type: 'line',
                        smooth: true,
                        showSymbol: false,
                        symbol: 'circle',
                        symbolSize: 6,
                        lineStyle: { width: 2 },
                        emphasis: { focus: 'series' },
                        data: this.trendChartData.readCountList
                    }
                ]
            });
        }
    }
};
</script>

<style>
.el-main {
    /* background-color: #e9eef3; */
    /* color: #333; */
    text-align: left;
}
.el-card {
    margin: 10px;
}

/* ===================== 看板展示样式 ===================== */
.dashboard {
    --dash-border: #eef0f4;
    --dash-text: #1f2d3d;
    --dash-muted: #8a94a6;
    color: var(--dash-text);
}

/* 统一卡片外观 */
.dashboard .el-card {
    margin: 0 0 12px;
    border: 1px solid var(--dash-border);
    border-radius: 12px;
}

/* ---------- 概览指标卡片 ---------- */
.stat-card {
    position: relative;
    overflow: hidden;
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.stat-card:hover {
    transform: translateY(-2px);
}
/* 左侧色条，复用图标渐变色 */
.stat-card::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 3px;
    background: var(--stat-color);
}
.stat-card--collected {
    --stat-color: linear-gradient(135deg, #6a9cff, #3f6fff);
}
.stat-card--doc {
    --stat-color: linear-gradient(135deg, #67d6a5, #2bb673);
}
.stat-card--file {
    --stat-color: linear-gradient(135deg, #ffc46b, #f2a03d);
}
.stat-card--read {
    --stat-color: linear-gradient(135deg, #ff9aa2, #f2607a);
}
.stat-card .el-card__body {
    padding: 16px 18px;
}
.stat-card__inner {
    display: flex;
    align-items: center;
    gap: 14px;
}
.stat-card__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: none;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    color: #fff;
    background: var(--stat-color);
    box-shadow: 0 4px 10px rgba(31, 45, 61, 0.12);
}
.stat-card__main {
    min-width: 0;
}
.stat-card__label {
    font-size: 13px;
    color: var(--dash-muted);
}
.stat-card__value {
    margin-top: 4px;
    font-size: 26px;
    font-weight: 600;
    line-height: 1.15;
    font-variant-numeric: tabular-nums;
}

/* ---------- 面板（图表 / 表格） ---------- */
.panel-card .el-card__header {
    padding: 14px 18px;
    border-bottom: 1px solid var(--dash-border);
}
.panel-card .el-card__body {
    padding: 16px 18px;
}
.panel-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.panel-card__title {
    position: relative;
    padding-left: 10px;
    font-size: 15px;
    font-weight: 600;
}
.panel-card__title::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    width: 3px;
    height: 14px;
    margin-top: -7px;
    border-radius: 2px;
    background: linear-gradient(180deg, #6a9cff, #3f6fff);
}

.trend-chart {
    width: 100%;
    height: 300px;
}

/* ---------- 阅读记录表格 ---------- */
.read-log-table {
    --el-table-header-bg-color: #f7f9fc;
    font-size: 13px;
}
.read-log-table th.el-table__cell {
    color: var(--dash-muted);
    font-weight: 600;
}
.read-log-table .el-table__cell {
    padding: 8px 0;
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 700px) {
    .stat-card .el-card__body {
        padding: 12px 14px;
    }
    .stat-card__inner {
        gap: 10px;
    }
    .stat-card__icon {
        width: 38px;
        height: 38px;
        border-radius: 10px;
    }
    .stat-card__value {
        font-size: 22px;
    }
    .panel-card .el-card__body {
        padding: 12px;
    }
    .panel-card .el-card__header {
        padding: 12px 14px;
    }
    .trend-chart {
        height: 240px;
    }
}
</style>
